import React from "react";
import { STATE_CONSTANTS_PROGRAM } from "./useConstantState";
import { STYLE_COMMON_ICON_PROGRAM } from "./useStyle";
import { FunctionOpenInNewTab } from "radium-omnibus";

export const ICON_EXCLAMATION_TRIANGLE = ({ onClick, fill = "none" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{
        height: "80px",
        color: "orange",
        margin: "auto",
      }}
      fill={fill}
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
      />
    </svg>
  );
};

//DRAWER
export const ICON_DOCUMENT_BLUE = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7161 16.2227H8.49609"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7161 12.0371H8.49609"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2511 7.85938H8.49609"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.908 2.75C15.908 2.75 8.231 2.754 8.219 2.754C5.459 2.771 3.75 4.587 3.75 7.357V16.553C3.75 19.337 5.472 21.16 8.256 21.16C8.256 21.16 15.932 21.157 15.945 21.157C18.705 21.14 20.415 19.323 20.415 16.553V7.357C20.415 4.573 18.692 2.75 15.908 2.75Z"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_PROFILE_BLUE = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 15.3457C8.11731 15.3457 4.81445 15.9305 4.81445 18.2724C4.81445 20.6143 8.09636 21.22 11.9849 21.22C15.8525 21.22 19.1545 20.6343 19.1545 18.2933C19.1545 15.9524 15.8735 15.3457 11.9849 15.3457Z"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z"
        stroke="#3AB4ED"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_PAYMENT_BLUE = ({ className }) => {
  return <img loading="lazy" src="/icons/payment.svg" className={className} />;
};
export const ICON_FAQ_BLUE = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.0714 19.0699C16.0152 22.1263 11.4898 22.7867 7.78642 21.074C7.23971 20.8539 6.79148 20.676 6.36537 20.676C5.17849 20.683 3.70117 21.8339 2.93336 21.067C2.16555 20.2991 3.31726 18.8206 3.31726 17.6266C3.31726 17.2004 3.14642 16.7602 2.92632 16.2124C1.21283 12.5096 1.87411 7.98269 4.93026 4.92721C8.8316 1.02443 15.17 1.02443 19.0714 4.9262C22.9797 8.83501 22.9727 15.1681 19.0714 19.0699Z"
        stroke="#3AB4ED"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8847 6.704C12.9407 6.704 13.794 7.00267 14.4447 7.6C15.0954 8.19733 15.4207 8.99733 15.4207 10C15.4207 11.12 15.074 11.952 14.3807 12.496C13.6874 13.0293 12.7487 13.296 11.5647 13.296L11.5167 14.816H10.2527L10.1887 12.288H10.6527C11.7087 12.288 12.5354 12.128 13.1327 11.808C13.73 11.488 14.0287 10.8853 14.0287 10C14.0287 9.36 13.8367 8.85333 13.4527 8.48C13.0687 8.10667 12.5514 7.92 11.9007 7.92C11.2394 7.92 10.7167 8.10133 10.3327 8.464C9.95935 8.816 9.77269 9.30133 9.77269 9.92H8.39669C8.39669 9.28 8.54069 8.72 8.82869 8.24C9.11669 7.74933 9.52202 7.37067 10.0447 7.104C10.578 6.83733 11.1914 6.704 11.8847 6.704ZM10.8767 18.096C10.5994 18.096 10.3647 18 10.1727 17.808C9.98069 17.616 9.88469 17.3813 9.88469 17.104C9.88469 16.8267 9.98069 16.592 10.1727 16.4C10.3647 16.208 10.5994 16.112 10.8767 16.112C11.1434 16.112 11.3674 16.208 11.5487 16.4C11.7407 16.592 11.8367 16.8267 11.8367 17.104C11.8367 17.3813 11.7407 17.616 11.5487 17.808C11.3674 18 11.1434 18.096 10.8767 18.096Z"
        fill="#3AB4ED"
      />
    </svg>
  );
};
export const ICON_CONTACT_US_BLUE = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39912_286164)">
        <path
          d="M12.8611 22.1L12.8613 22.1C13.0923 22.0995 13.3201 22.0455 13.5267 21.9422C13.7182 21.8465 13.8867 21.7107 14.021 21.5444H15.3333H15.3334C16.4396 21.5434 17.5074 21.139 18.3367 20.407C19.1441 19.6943 19.6714 18.7188 19.8263 17.655C20.4246 17.6426 20.9958 17.3994 21.4198 16.9754C21.8553 16.5399 22.1 15.9492 22.1 15.3333V12.5556C22.1 11.9397 21.8553 11.349 21.4198 10.9135C21.008 10.5016 20.4573 10.2604 19.8778 10.2355V9.77778C19.8778 7.68846 19.0478 5.68472 17.5704 4.20735C16.0931 2.72998 14.0893 1.9 12 1.9C9.91068 1.9 7.90694 2.72998 6.42957 4.20735C4.9522 5.68472 4.12222 7.68846 4.12222 9.77778V10.2355C3.5427 10.2604 2.99204 10.5016 2.58016 10.9135C2.14466 11.349 1.9 11.9397 1.9 12.5556V15.3333C1.9 15.9492 2.14466 16.5399 2.58016 16.9754C3.01566 17.4109 3.60633 17.6556 4.22222 17.6556H5.88889C6.06275 17.6556 6.2295 17.5865 6.35244 17.4635C6.47538 17.3406 6.54444 17.1739 6.54444 17V10.8889C6.54444 10.715 6.47538 10.5483 6.35244 10.4253C6.2295 10.3024 6.06275 10.2333 5.88889 10.2333H5.43333V9.77778C5.43333 8.03619 6.12518 6.36593 7.35667 5.13444C8.58815 3.90295 10.2584 3.21111 12 3.21111C13.7416 3.21111 15.4118 3.90295 16.6433 5.13444C17.8748 6.36593 18.5667 8.03619 18.5667 9.77778V10.2333H18.1111C17.9372 10.2333 17.7705 10.3024 17.6476 10.4253C17.5246 10.5483 17.4556 10.715 17.4556 10.8889V17C17.4556 17.1739 17.5246 17.3406 17.6476 17.4635C17.7705 17.5865 17.9372 17.6556 18.1111 17.6556H18.4961C18.3498 18.3622 17.971 19.0009 17.4183 19.4684C16.8354 19.9616 16.0968 20.2326 15.3332 20.2333H14.3016C14.2218 19.9292 14.0476 19.6574 13.8029 19.4577C13.537 19.2407 13.2043 19.1222 12.8611 19.1222H11.1944C10.7996 19.1222 10.4209 19.2791 10.1416 19.5583C9.86242 19.8375 9.70556 20.2162 9.70556 20.6111C9.70556 21.006 9.86242 21.3847 10.1416 21.6639C10.4209 21.9431 10.7996 22.1 11.1944 22.1H12.8611ZM12.8333 20.7889H11.1667C11.1195 20.7889 11.0743 20.7702 11.041 20.7368C11.0076 20.7035 10.9889 20.6583 10.9889 20.6111C10.9889 20.564 11.0076 20.5187 11.041 20.4854C11.0743 20.4521 11.1195 20.4333 11.1667 20.4333H12.8333C12.8805 20.4333 12.9257 20.4521 12.959 20.4854C12.9924 20.5187 13.0111 20.564 13.0111 20.6111C13.0111 20.6583 12.9924 20.7035 12.959 20.7368C12.9257 20.7702 12.8805 20.7889 12.8333 20.7889ZM20.7889 12.5556V15.3333C20.7889 15.6015 20.6824 15.8587 20.4927 16.0483C20.3031 16.2379 20.0459 16.3444 19.7778 16.3444H18.7667V11.5444H19.7778C20.0459 11.5444 20.3031 11.651 20.4927 11.8406C20.6824 12.0302 20.7889 12.2874 20.7889 12.5556ZM3.21111 12.5556C3.21111 12.2874 3.31764 12.0302 3.50726 11.8406C3.69688 11.651 3.95406 11.5444 4.22222 11.5444H5.23333V16.3444H4.22222C3.95406 16.3444 3.69688 16.2379 3.50726 16.0483C3.31764 15.8587 3.21111 15.6015 3.21111 15.3333V12.5556Z"
          fill="#3AB4ED"
          stroke="#3AB4ED"
          strokeWidth="0.2"
        />
        <path
          d="M11.9996 17.2101C12.5345 17.213 13.0626 17.0896 13.5408 16.8499C14.0192 16.6102 14.4343 16.261 14.7523 15.8306L14.7527 15.8301C14.8035 15.7604 14.84 15.6814 14.8603 15.5975C14.8805 15.5137 14.884 15.4267 14.8706 15.3415C14.8572 15.2563 14.8272 15.1746 14.7822 15.101C14.7373 15.0274 14.6782 14.9634 14.6085 14.9126C14.5388 14.8618 14.4598 14.8253 14.376 14.8051C14.2921 14.7848 14.2051 14.7813 14.1199 14.7947C14.0347 14.8081 13.953 14.8381 13.8794 14.8831C13.8061 14.9279 13.7423 14.9866 13.6916 15.056C13.4938 15.3173 13.2382 15.5292 12.9448 15.6751C12.6511 15.8212 12.3276 15.8972 11.9996 15.8972C11.6717 15.8972 11.3482 15.8212 11.0545 15.6751C10.7611 15.5292 10.5055 15.3173 10.3077 15.056C10.257 14.9866 10.1932 14.9279 10.1199 14.8831C10.0463 14.8381 9.96457 14.8081 9.87937 14.7947C9.79417 14.7813 9.70718 14.7848 9.62334 14.8051C9.53951 14.8253 9.46048 14.8618 9.39077 14.9126C9.32106 14.9634 9.26203 15.0274 9.21706 15.101C9.17209 15.1746 9.14205 15.2563 9.12866 15.3415C9.11528 15.4267 9.1188 15.5137 9.13904 15.5975C9.15927 15.6814 9.19582 15.7604 9.24659 15.8301L9.24659 15.8301L9.247 15.8306C9.56499 16.261 9.98006 16.6102 10.4585 16.8499C10.9367 17.0896 11.4647 17.213 11.9996 17.2101ZM11.9996 17.2101C11.9995 17.2101 11.9993 17.2101 11.9991 17.2101L11.9996 17.1101L12.0002 17.2101C12 17.2101 11.9998 17.2101 11.9996 17.2101Z"
          fill="#3AB4ED"
          stroke="#3AB4ED"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_39912_286164">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ICON_MORE_SQUARE = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.334 2.75H7.665C4.644 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.634 21.25 7.665 21.25H16.333C19.364 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.364 2.75 16.334 2.75Z"
        stroke="#3AB4ED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9389 12.0137H15.9479"
        stroke="#3AB4ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.931 12.0137H11.94"
        stroke="#3AB4ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.92128 12.0137H7.93028"
        stroke="#3AB4ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_CONTACT_US = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81658 8.09274C8.81658 8.47701 8.50641 8.78889 8.12423 8.78889C7.74204 8.78889 7.43187 8.47701 7.43187 8.09274C7.43187 5.55968 9.48125 3.5 12.0005 3.5C14.5188 3.5 16.5682 5.55968 16.5682 8.09274C16.5682 10.6258 14.5188 12.6855 12.0005 12.6855C10.9694 12.6855 9.99728 12.3523 9.19046 11.7211C8.88859 11.4853 8.83412 11.0481 9.0686 10.7446C9.30216 10.4402 9.7388 10.3863 10.0407 10.623C10.6019 11.0611 11.2795 11.2932 12.0005 11.2932C13.7563 11.2932 15.1835 9.85725 15.1835 8.09274C15.1835 6.32823 13.7563 4.8923 12.0005 4.8923C10.2447 4.8923 8.81658 6.32823 8.81658 8.09274ZM7.0207 10.9852C7.0207 11.3695 6.71052 11.6813 6.32834 11.6813C4.33527 11.6813 2.71331 10.0514 2.71331 8.04744C2.71331 6.04346 4.33527 4.41261 6.32834 4.41261C6.71052 4.41261 7.0207 4.72448 7.0207 5.10876C7.0207 5.49303 6.71052 5.80491 6.32834 5.80491C5.09871 5.80491 4.09803 6.81108 4.09803 8.04744C4.09803 9.28381 5.09871 10.289 6.32834 10.289C6.71052 10.289 7.0207 10.6009 7.0207 10.9852ZM5.03114 14.872C4.58618 14.9017 4.13938 14.9676 3.70273 15.066C3.03253 15.1988 2.57188 15.4252 2.4528 15.6759C2.36325 15.8661 2.36325 16.0861 2.4528 16.2764C2.51003 16.3961 2.74267 16.6941 3.69073 16.8899C4.06553 16.967 4.30647 17.3346 4.22985 17.7114C4.16338 18.0409 3.87444 18.2674 3.55226 18.2674C3.50611 18.2674 3.45995 18.2628 3.41287 18.2535C2.26725 18.0177 1.52412 17.5536 1.20286 16.8742C0.93238 16.3033 0.93238 15.6489 1.20286 15.0781C1.52781 14.3922 2.27278 13.929 3.41748 13.7025C3.90583 13.593 4.42371 13.5178 4.9379 13.4835C5.30716 13.4547 5.64965 13.7471 5.67549 14.1304C5.70134 14.5147 5.41332 14.847 5.03114 14.872ZM17.6833 10.3117C17.3011 10.3117 16.9909 10.6236 16.9909 11.0078C16.9909 11.3921 17.3011 11.704 17.6833 11.704C19.6717 11.704 21.29 10.0769 21.29 8.07752C21.29 6.07724 19.6717 4.45103 17.6833 4.45103C17.3011 4.45103 16.9909 4.76198 16.9909 5.14719C16.9909 5.53146 17.3011 5.84334 17.6833 5.84334C18.9083 5.84334 19.9053 6.84579 19.9053 8.07752C19.9053 9.30924 18.9083 10.3117 17.6833 10.3117ZM20.6028 13.7196C21.73 13.9442 22.4731 14.4055 22.7971 15.0878C23.0676 15.6586 23.0676 16.312 22.7971 16.8829C22.4768 17.5596 21.7355 18.0227 20.5917 18.2594C20.5456 18.2696 20.4985 18.2743 20.4514 18.2743C20.1302 18.2743 19.8422 18.0469 19.7748 17.7183C19.6981 17.3414 19.9391 16.9729 20.3139 16.8959C21.2583 16.7 21.4909 16.403 21.5472 16.2842C21.6367 16.0949 21.6367 15.8767 21.5472 15.6874C21.429 15.4377 20.9702 15.2121 20.3185 15.0822C19.8652 14.9819 19.4184 14.916 18.9772 14.8863C18.595 14.8613 18.307 14.528 18.3328 14.1447C18.3577 13.7614 18.691 13.4773 19.0695 13.4977C19.5818 13.5321 20.0969 13.6073 20.6028 13.7196ZM12.0002 14.126C10.333 14.126 5.26036 14.126 5.26036 17.3218C5.26036 18.0431 5.54284 19.0418 6.88878 19.7055C7.30235 19.9078 7.80269 20.073 8.37689 20.1965C8.74892 20.28 9.11817 20.0368 9.19757 19.6609C9.27788 19.285 9.03878 18.9146 8.66491 18.8348C8.20149 18.7355 7.80823 18.6074 7.49806 18.4542C6.742 18.082 6.64507 17.6541 6.64507 17.3218C6.64507 15.8311 9.55759 15.5183 12.0002 15.5183C15.5543 15.5183 17.3554 16.1189 17.3554 17.3051C17.3554 18.7949 14.4429 19.1077 12.0002 19.1077C11.618 19.1077 11.3079 19.4196 11.3079 19.8038C11.3079 20.1881 11.618 20.5 12.0002 20.5C13.6674 20.5 18.7401 20.5 18.7401 17.3051C18.7401 14.126 13.8437 14.126 12.0002 14.126Z"
        fill="#3AB4ED"
      />
    </svg>
  );
};
export const ICON_DISCOUNT = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_39908_286119"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="24"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2H22.0027V22.001H2V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_39908_286119)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9447 20.0754C11.5347 20.6514 12.4847 20.6444 13.0707 20.0554L13.7927 19.3354C14.3527 18.7764 15.1267 18.4574 15.9157 18.4574H16.9457C17.7797 18.4574 18.4577 17.7794 18.4577 16.9464V15.9174C18.4577 15.1164 18.7677 14.3634 19.3337 13.7964L20.0537 13.0754C20.3467 12.7814 20.5037 12.4004 20.5027 11.9964C20.5017 11.5934 20.3427 11.2144 20.0557 10.9284L19.3347 10.2064C18.7677 9.63539 18.4577 8.88339 18.4577 8.08239V7.05539C18.4577 6.22139 17.7797 5.54339 16.9457 5.54339H15.9177C15.1167 5.54339 14.3637 5.23239 13.7967 4.66939L13.0747 3.94639C12.4737 3.35139 11.5147 3.35439 10.9277 3.94539L10.2087 4.66639C9.63472 5.23339 8.88172 5.54339 8.08372 5.54339H7.05472C6.22172 5.54439 5.54372 6.22239 5.54372 7.05539V8.08039C5.54372 8.88139 5.23272 9.63439 4.66872 10.2024L3.95872 10.9134C3.95172 10.9214 3.94472 10.9274 3.93772 10.9344C3.35072 11.5254 3.35372 12.4844 3.94472 13.0714L4.66672 13.7934C5.23272 14.3614 5.54372 15.1144 5.54372 15.9154V16.9464C5.54372 17.7794 6.22072 18.4574 7.05472 18.4574H8.08172C8.88372 18.4584 9.63672 18.7694 10.2037 19.3344L10.9247 20.0534C10.9307 20.0604 10.9377 20.0674 10.9447 20.0754V20.0754ZM11.9987 22.0014C11.2317 22.0014 10.4647 21.7114 9.87772 21.1294C9.86972 21.1214 9.86172 21.1134 9.85372 21.1044L9.14372 20.3954C8.86072 20.1144 8.48272 19.9584 8.08072 19.9574H7.05472C5.39372 19.9574 4.04372 18.6064 4.04372 16.9464V15.9154C4.04372 15.5134 3.88672 15.1364 3.60472 14.8524L2.88572 14.1344C1.71772 12.9724 1.70372 11.0804 2.85072 9.90039C2.85972 9.89139 2.86872 9.88239 2.87772 9.87339L3.60572 9.14339C3.88672 8.86039 4.04372 8.48139 4.04372 8.08039V7.05539C4.04372 5.39539 5.39372 4.04439 7.05372 4.04339H8.08372C8.48472 4.04339 8.86272 3.88639 9.14972 3.60339L9.86472 2.88639C11.0337 1.70939 12.9447 1.70339 14.1237 2.87539L14.8547 3.60639C15.1377 3.88739 15.5157 4.04339 15.9177 4.04339H16.9457C18.6067 4.04339 19.9577 5.39439 19.9577 7.05539V8.08239C19.9577 8.48339 20.1137 8.86239 20.3967 9.14739L21.1147 9.86639C21.6837 10.4314 21.9997 11.1864 22.0027 11.9914C22.0057 12.7964 21.6947 13.5534 21.1277 14.1244L20.3947 14.8554C20.1137 15.1384 19.9577 15.5154 19.9577 15.9174V16.9464C19.9577 18.6064 18.6067 19.9574 16.9467 19.9574H15.9157C15.5197 19.9574 15.1327 20.1174 14.8517 20.3964L14.1337 21.1144C13.5467 21.7054 12.7727 22.0014 11.9987 22.0014V22.0014Z"
          fill="#3AB4ED"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42944 15.3204C9.23744 15.3204 9.04544 15.2474 8.89944 15.1004C8.60644 14.8074 8.60644 14.3334 8.89944 14.0404L14.0394 8.89944C14.3324 8.60644 14.8074 8.60644 15.1004 8.89944C15.3934 9.19244 15.3934 9.66744 15.1004 9.96044L9.95944 15.1004C9.81344 15.2474 9.62144 15.3204 9.42944 15.3204"
        fill="#3AB4ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.503 15.498C13.95 15.498 13.498 15.051 13.498 14.498C13.498 13.945 13.941 13.498 14.494 13.498H14.503C15.056 13.498 15.503 13.945 15.503 14.498C15.503 15.051 15.056 15.498 14.503 15.498"
        fill="#3AB4ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50305 10.498C8.95005 10.498 8.49805 10.051 8.49805 9.49805C8.49805 8.94505 8.94105 8.49805 9.49405 8.49805H9.50305C10.056 8.49805 10.503 8.94505 10.503 9.49805C10.503 10.051 10.056 10.498 9.50305 10.498"
        fill="#3AB4ED"
      />
    </svg>
  );
};

export const ICON_MORE = ({ className }) => {
  return <img loading="lazy" src="/icons/more.svg" className={className} />;
};
export const ICON_LOGIN = ({
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <img
      loading="lazy"
      src="/icons/login.svg"
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
export const ICON_LOGIN_GRAY = ({
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7715 10.0225H0.771484"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8848 7.10645L14.8128 10.0224L11.8848 12.9384"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50391 5.38946V4.45646C6.50391 2.42146 8.15291 0.772461 10.1889 0.772461H15.0729C17.1029 0.772461 18.7479 2.41746 18.7479 4.44746V15.5875C18.7479 17.6225 17.0979 19.2725 15.0629 19.2725H10.1779C8.14891 19.2725 6.50391 17.6265 6.50391 15.5975V14.6555"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_LOGOUT = ({
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <img
      loading="lazy"
      src="/icons/logout.svg"
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
export const ICON_LOGOUT_GRAY = ({ className, onClick, className_arrow }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9207 5.618V4.685C11.9207 2.65 10.449 1 8.63398 1H4.28585C2.47167 1 1 2.65 1 4.685V15.815C1 17.85 2.47167 19.5 4.28585 19.5H8.6429C10.4526 19.5 11.9207 17.855 11.9207 15.826V14.883"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9799 10.25H7.24023"
        className={className_arrow}
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3672 7.33594L17.9787 10.2509L15.3672 13.1669"
        className={className_arrow}
        stroke="CurrentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_X = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

//BUSKET
export const ICON_ADDRESS_DETAILS = ({ className }) => {
  return (
    <img loading="lazy" src="/icons/addressdetails.svg" className={className} />
  );
};
export const ICON_SAMEDAY_SERVICE = ({ className }) => {
  return (
    <img loading="lazy" src="/icons/samedayservice.svg" className={className} />
  );
};
export const ICON_SAMEDAY_SERVICE_DISABLE = ({ className }) => {
  return (
    <img
      loading="lazy"
      src="/icons/samedayservice_disable.svg"
      className={className}
    />
  );
};

export const ICON_DATE_TIME = ({ className }) => {
  return <img loading="lazy" src="/icons/datetime.svg" className={className} />;
};
export const ICON_EMPTY_BASKET = ({ className }) => {
  return (
    <img loading="lazy" src="/images/empty_busket.png" className={className} />
  );
};

//ORDER
export const ICON_EMPTY_ORDER = ({ className }) => {
  return (
    <img loading="lazy" src="/images/empty_order.png" className={className} />
  );
};
export const ICON_CASH = ({ className }) => {
  return <img loading="lazy" src="/icons/cash.svg" className={className} />;
};
export const ICON_CUP = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="30px"
      height="30px"
    >
      <path
        fill="#e21836"
        d="M10.09,9h11.585c1.617,0,2.623,1.362,2.246,3.039l-5.394,23.927c-0.381,1.671-2,3.034-3.618,3.034 H3.325C1.956,38.999,1.023,38.02,1,36.704c-0.004-0.237,0.021-0.484,0.079-0.739l5.396-23.927C6.852,10.362,8.471,9,10.09,9"
      />
      <path
        fill="#00447c"
        d="M20.5,9h13.47c1.657,0,0.91,1.362,0.52,3.039l-5.527,23.928C28.575,37.637,28.696,39,27.035,39H13.38 c-1.39,0-2.336-0.955-2.379-2.246c-0.008-0.251,0.018-0.516,0.081-0.788l5.711-23.928C17.187,10.362,18.657,9,20.316,9"
      />
      <path
        fill="#007b84"
        d="M33.273,9h11.401c1.183,0,2.039,0.727,2.266,1.773c0.044,0.204,0.064,0.42,0.059,0.645 c-0.005,0.2-0.031,0.408-0.079,0.62l-5.393,23.928C41.146,37.637,39.525,39,37.906,39h-11.58c-1.355,0-2.279-0.953-2.324-2.241 c-0.009-0.253,0.016-0.518,0.078-0.792l5.578-23.928C30.036,10.362,31.653,9,33.273,9z"
      />
      <path
        fill="#fefefe"
        d="M19.364 18.117c-.325-.195-.905-.134-1.302.135-.396.263-.45.636-.126.833.319.189.902.134 1.296-.137C19.626 18.68 19.685 18.31 19.364 18.117zM42.308 19.376l-1.171 2.048L40.874 19l-1.24.294.454 3.963-1.415 2.293c-.038.054-.072.091-.119.107-.052.025-.118.03-.21.03h-.04L38 26.624l.75.001c.53-.002.904-.288 1.092-.625L44 19 42.308 19.376zM22.157 25l-.404.701C21.666 25.854 21.518 26 21.19 26h-.201l-.282.875h.668c.787 0 1.158-.431 1.158-.431h2.086l.301-.933h-1.752l.28-.51L22.157 25zM10.416 19.885c-.194.75-.341 1.24-.679 1.585-.233.238-.593.351-.923.35-.493 0-.91-.311-.883-.823.002-.038.007-.078.014-.119C8.187 19.531 9.242 16 9.242 16H7.275l-1.02 4.03c0 0-.25.968-.255 1.379-.004.313.047.569.164.785C6.54 22.879 7.652 23 8.288 23c1.088 0 1.731-.104 2.257-.424.839-.51 1.082-1.2 1.341-2.175C12.178 19.305 13 16 13 16h-1.595C11.405 16 10.417 19.883 10.416 19.885zM13.701 23l.705-2.869C14.559 20.065 14.709 20 14.851 20c.338 0 .414.281.397.393C15.234 20.529 14.658 23 14.658 23h1.404l.491-2.068c.204-.764.307-1.152.177-1.468C16.594 19.111 16.246 19 15.924 19c-.21 0-.596.073-.946.234-.127.061-.247.132-.374.202l.103-.438-1.493.234L12.25 23H13.701zM25.576 23l.705-2.869C26.434 20.065 26.584 20 26.726 20c.338 0 .414.281.397.393C27.109 20.529 26.533 23 26.533 23h1.404l.491-2.068c.204-.764.307-1.152.177-1.468C28.469 19.111 28.121 19 27.799 19c-.21 0-.596.073-.946.234-.127.061-.247.132-.374.202l.103-.438-1.493.234L24.125 23H25.576zM17 23L18.451 23 19.201 20 17.715 20.22zM35.424 16.62c-.414-.603-1.269-.615-2.257-.62-.001 0-.727 0-.727 0h-1.614L29 23h1.579l.665-2.5h.294c1.007 0 1.972-.014 2.809-.618.585-.426 1.033-.992 1.228-1.757.05-.187.09-.41.096-.633C35.678 17.199 35.588 16.847 35.424 16.62zM33.742 18.19c-.115.467-.428.86-.822 1.049-.324.16-.721.137-1.125.136h-.252L32.175 17c.142 0 .38 0 .62 0 .75 0 .988.477.986.875C33.781 17.978 33.768 18.084 33.742 18.19zM28.47 29c0 0-.075.219-.099.293-.02.063-.1.207-.327.207h-.419V29H26.5v2.5c-.007.183.179.5.998.5h.932l.286-.876-.84.001c-.25 0-.245-.116-.248-.3-.003-.2-.003-.575-.003-.575h.794c.73 0 .89-.606.946-.787L29.474 29H28.47z"
      />
      <path
        fill="#fefefe"
        d="M28.824 25c-1.502 0-1.795.67-1.795.67L27.235 25h-1.21l-1.979 6.083c-.021.07-.048.18-.046.299C24.006 31.664 24.174 32 24.964 32l.718-.001L26.002 31c0 0-.36 0-.485 0-.157 0-.125-.13-.125-.13l.709-2.152h1.778c1.47 0 1.743-.9 1.875-1.31L30.538 25C30.538 25 29.369 25 28.824 25zM28.298 28h-2.001l.206-.604h2.005L28.298 28zM28.822 26.518c0 0-1.012-.01-1.175.02-.717.124-1.018.508-1.018.508L26.967 26h2.023L28.822 26.518zM37.507 19.234c0 0-.01.04-.028.111C37.325 19.179 37.07 19 36.668 19c-.5 0-.937.179-1.45.617-.451.39-.677.926-.811 1.439-.052.19-.083.491-.083.694 0 1.25 1.082 1.25 1.345 1.25.395 0 .71-.151.965-.347C36.602 22.776 36.543 23 36.543 23h1.451L39 19 37.507 19.234zM36.098 22.116c-.063 0-.438 0-.429-.411.004-.203.052-.43.125-.691.17-.608.399-1.139 1-1.139.47 0 .461.377.26 1.133-.058.217-.221.609-.348.8C36.521 22.086 36.31 22.116 36.098 22.116zM23.768 19.493C23.471 19.12 22.93 19.001 22.366 19c-.339 0-1.149.031-1.796.579-.465.396-.69.934-.831 1.449-.142.525-.316 1.471.596 1.824C20.616 22.968 21.025 23 21.29 23c.675.001 1.372-.174 1.908-.695.413-.422.614-1.051.685-1.31C24.114 20.138 23.964 19.737 23.768 19.493zM21.429 22.115c-.063 0-.438 0-.429-.411.004-.203.06-.471.125-.691.169-.572.4-1.139 1-1.139.47 0 .461.377.26 1.133-.058.217-.221.609-.348.8C21.852 22.086 21.641 22.116 21.429 22.115zM20.847 27.115L20.556 28h.846l-.248.769h-.848L20 29.706h.845l-.536 1.639c-.072.217-.075.654.738.654h1.627L23 31c0 0-.931 0-1.181 0s-.183-.177-.183-.177l.368-1.132h1.746l.302-.921h-1.747L22.56 28h1.713l.297-.885H20.847zM39.7 27.916L40 27h-4.037l-.294.916h1.211l-.247.743h-1.232l-.263.812h1.082l-.963 1.265C35.18 30.847 35.017 31 34.749 31h-.486l.095-.289H33.94L35.479 26h.547l.172-.518c0 0 0 .381 0 .517 0 .434.125.626.821.626h.478L37.8 25.69h-.223c-.147.003-.217-.044-.205-.138V25c0 0-.799 0-1.25 0-1.175 0-1.903.055-2.193.132-.351.09-.807.357-.807.357L33.279 25H31.98l-1.862 5.722h-.28L29.52 31.69h2.874L32.293 32h1.229l.1-.31h.402L33.919 32h1.02c.259 0 .468-.058.642-.155.182-.101.325-.244.447-.407l.756-1.006.115 1.055C36.928 31.679 37.002 32 37.791 32h.568l.329-1h-.371c-.265 0-.322-.195-.337-.297l-.132-1.024h-.615l.25-.208h1.703l.268-.812h-1.585l.251-.743C38.12 27.916 39.7 27.916 39.7 27.916zM32.964 26h1.303l-.278.853c0 0-.462.028-.693.08-.393.09-.72.248-.72.248L32.964 26zM32.729 30.722h-1.306l.347-1.064h1.303L32.729 30.722zM33.408 28.622c0 0-.346.043-.574.095C32.435 28.832 31.979 29 31.979 29l.4-1.218h1.308L33.408 28.622z"
      />
    </svg>
  );
};

export const ICON_VISA = ({ className }) => {
  return <img loading="lazy" src="/icons/visa.svg" className={className} />;
};
export const ICON_MASTERCARD = ({ className }) => {
  return (
    <img
      loading="lazy"
      src="/icons/mastercard.svg"
      className={className + " -ml-1"}
    />
  );
};
export const ICON_PROMPAY = ({ className }) => {
  return <img loading="lazy" src="/icons/qr_code.svg" className={className} />;
};

export const ICON_JCB = ({ className = "" }) => {
  return <img className={className} src="/icons/jcb.png" />;
};

//NAVBAR
export const ICON_MENU = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.09082H0.999999"
        stroke=" currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.333 11.0908H0.999674"
        stroke=" currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66699 17.0908H1.00033"
        stroke=" currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_LOCATION = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_DOCUMENT = ({ className, onClick }) => {
  return (
    <img
      loading="lazy"
      onClick={onClick}
      src="/icons/document.svg"
      className={className}
    />
  );
};
export const ICON_BASKET = ({ className, onClick }) => {
  return (
    // <img loading="lazy"  onClick={onClick} src="/icons/basket.svg" className={className} />
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L3.24865 1.39908L4.28974 14.1174C4.37298 15.1561 5.21947 15.9532 6.23569 15.9499H18.0292C18.999 15.9521 19.8217 15.2204 19.959 14.2361L20.9849 6.9662C21.0995 6.15363 20.5492 5.39982 19.7579 5.28232C19.6887 5.27234 3.60973 5.2668 3.60973 5.2668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2969 9.36384H16.2947"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.76096 19.793C6.08637 19.793 6.34907 20.0635 6.34907 20.396C6.34907 20.7297 6.08637 21.0002 5.76096 21.0002C5.43555 21.0002 5.17285 20.7297 5.17285 20.396C5.17285 20.0635 5.43555 19.793 5.76096 19.793Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9563 19.793C18.2817 19.793 18.5455 20.0635 18.5455 20.396C18.5455 20.7297 18.2817 21.0002 17.9563 21.0002C17.6309 21.0002 17.3682 20.7297 17.3682 20.396C17.3682 20.0635 17.6309 19.793 17.9563 19.793Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

//FOOTER
export const ICON_GERMANY = ({ className }) => {
  return (
    <svg
      width="30"
      height="20"
      viewBox="0 0 30 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_39985_286162)">
        <path d="M30 0H0V20.0002H30V0Z" fill="#D80027" />
        <path d="M30 0H0V6.6665H30V0Z" fill="black" />
        <path d="M30 13.332H0V19.9985H30V13.332Z" fill="#FFDA44" />
      </g>
      <rect
        x="0.3"
        y="0.3"
        width="29.4"
        height="19.4"
        rx="2.7"
        stroke="#6E7191"
        stroke-width="0.6"
      />
      <defs>
        <clipPath id="clip0_39985_286162">
          <rect width="30" height="20" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ICON_YOUTUBE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M21.543 6.498C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5l6-3.5-6-3.5v7z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ICON_FACEBOOK = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ICON_LINE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M18.663 10.84a.526.526 0 0 1-.526.525h-1.462v.938h1.462a.525.525 0 1 1 0 1.049H16.15a.526.526 0 0 1-.522-.524V8.852c0-.287.235-.525.525-.525h1.988a.525.525 0 0 1-.003 1.05h-1.462v.938h1.462c.291 0 .526.237.526.525zm-4.098 2.485a.538.538 0 0 1-.166.025.515.515 0 0 1-.425-.208l-2.036-2.764v2.45a.525.525 0 0 1-1.047 0V8.852a.522.522 0 0 1 .52-.523c.162 0 .312.086.412.211l2.052 2.775V8.852c0-.287.235-.525.525-.525.287 0 .525.238.525.525v3.976a.524.524 0 0 1-.36.497zm-4.95.027a.526.526 0 0 1-.523-.524V8.852c0-.287.236-.525.525-.525.289 0 .524.238.524.525v3.976a.527.527 0 0 1-.526.524zm-1.53 0H6.098a.528.528 0 0 1-.525-.524V8.852a.527.527 0 0 1 1.05 0v3.45h1.464a.525.525 0 0 1 0 1.05zM12 2.572c-5.513 0-10 3.643-10 8.118 0 4.01 3.558 7.369 8.363 8.007.325.068.769.215.881.492.1.25.066.638.032.9l-.137.85c-.037.25-.2.988.874.537 1.076-.449 5.764-3.398 7.864-5.812C21.313 14.089 22 12.477 22 10.69c0-4.475-4.488-8.118-10-8.118z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ICON_TIKTOK = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258a6.228 6.228 0 0 1-1.137-.966c-.849-.971-1.166-1.956-1.282-2.645h.004c-.097-.573-.057-.943-.05-.943h-3.865v14.943c0 .2 0 .399-.008.595c0 .024-.003.046-.004.073c0 .01 0 .022-.003.033v.009a3.28 3.28 0 0 1-1.65 2.604a3.226 3.226 0 0 1-1.6.422c-1.8 0-3.26-1.468-3.26-3.281c0-1.814 1.46-3.282 3.26-3.282c.341 0 .68.054 1.004.16l.005-3.936a7.178 7.178 0 0 0-5.532 1.62a7.583 7.583 0 0 0-1.655 2.04c-.163.281-.779 1.412-.853 3.246c-.047 1.04.266 2.12.415 2.565v.01c.093.262.457 1.158 1.049 1.913a7.856 7.856 0 0 0 1.674 1.58v-.01l.009.01c1.87 1.27 3.945 1.187 3.945 1.187c.359-.015 1.562 0 2.928-.647c1.515-.718 2.377-1.787 2.377-1.787a7.43 7.43 0 0 0 1.296-2.153c.35-.92.466-2.022.466-2.462V8.273c.047.028.672.441.672.441s.9.577 2.303.952c1.006.267 2.363.324 2.363.324V6.153c-.475.052-1.44-.098-2.429-.59Z"
      />
    </svg>
  );
};
export const ICON_IG = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm6.5-.25a1.25 1.25 0 0 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM12 4c-2.474 0-2.878.007-4.029.058-.784.037-1.31.142-1.798.332-.434.168-.747.369-1.08.703a2.89 2.89 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.006 9.075 4 9.461 4 12c0 2.474.007 2.878.058 4.029.037.783.142 1.31.331 1.797.17.435.37.748.702 1.08.337.336.65.537 1.08.703.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.474 0 2.878-.007 4.029-.058.782-.037 1.309-.142 1.797-.331.433-.169.748-.37 1.08-.702.337-.337.538-.65.704-1.08.19-.493.296-1.02.332-1.8.052-1.104.058-1.49.058-4.029 0-2.474-.007-2.878-.058-4.029-.037-.782-.142-1.31-.332-1.798a2.911 2.911 0 0 0-.703-1.08 2.884 2.884 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.925 4.006 14.539 4 12 4zm0-2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ICON_TWITTER = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M22.162 5.656a8.384 8.384 0 0 1-2.402.658A4.196 4.196 0 0 0 21.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.62-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.21 4.21 0 0 1-1.89.072A4.185 4.185 0 0 0 7.97 16.65a8.394 8.394 0 0 1-6.191 1.732 11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.496 8.496 0 0 0 2.087-2.165z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ICON_PINTEREST = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 32 32"
    >
      <path
        fill="currentColor"
        d="M16.75.406C10.337.406 4 4.681 4 11.6c0 4.4 2.475 6.9 3.975 6.9c.619 0 .975-1.725.975-2.212c0-.581-1.481-1.819-1.481-4.238c0-5.025 3.825-8.588 8.775-8.588c4.256 0 7.406 2.419 7.406 6.863c0 3.319-1.331 9.544-5.644 9.544c-1.556 0-2.888-1.125-2.888-2.737c0-2.363 1.65-4.65 1.65-7.088c0-4.137-5.869-3.387-5.869 1.613c0 1.05.131 2.212.6 3.169c-.863 3.713-2.625 9.244-2.625 13.069c0 1.181.169 2.344.281 3.525c.212.238.106.213.431.094c3.15-4.313 3.038-5.156 4.463-10.8c.769 1.463 2.756 2.25 4.331 2.25c6.637 0 9.619-6.469 9.619-12.3c0-6.206-5.363-10.256-11.25-10.256z"
      />
    </svg>
  );
};
export const ICON_MESSENGER_WHITE = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94c8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57C504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
      />
    </svg>
  );
};
export const ICON_WHATSAPP_WHITE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <g fill="none">
        <g clip-path="url(#svgIDa)">
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.415 14.382c-.298-.149-1.759-.867-2.031-.967c-.272-.099-.47-.148-.669.15c-.198.296-.767.966-.94 1.164c-.174.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.019-.458.13-.606c.134-.133.297-.347.446-.52c.149-.174.198-.298.297-.497c.1-.198.05-.371-.025-.52c-.074-.149-.668-1.612-.916-2.207c-.241-.579-.486-.5-.668-.51c-.174-.008-.372-.01-.57-.01c-.198 0-.52.074-.792.372c-.273.297-1.04 1.016-1.04 2.479c0 1.462 1.064 2.875 1.213 3.074c.149.198 2.095 3.2 5.076 4.487c.71.306 1.263.489 1.694.625c.712.227 1.36.195 1.872.118c.57-.085 1.758-.719 2.006-1.413c.247-.694.247-1.289.173-1.413c-.074-.124-.272-.198-.57-.347Zm-5.422 7.403h-.004a9.87 9.87 0 0 1-5.032-1.378l-.36-.214l-3.742.982l.999-3.648l-.235-.374a9.861 9.861 0 0 1-1.511-5.26c.002-5.45 4.436-9.884 9.889-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.993c-.002 5.45-4.436 9.885-9.884 9.885Zm8.412-18.297A11.815 11.815 0 0 0 11.992 0C5.438 0 .102 5.335.1 11.892a11.864 11.864 0 0 0 1.587 5.945L0 24l6.304-1.654a11.881 11.881 0 0 0 5.684 1.448h.005c6.554 0 11.89-5.335 11.892-11.893a11.821 11.821 0 0 0-3.48-8.413"
            clipRule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="svgIDa">
            <path fill="currentColor" d="M0 0h24v24H0z" />
          </clipPath>
        </defs>
      </g>
    </svg>
  );
};

//PROGRAMS

export const ICON_PROGRAM_MYWASH = ({ className }) => {
  return <img loading="lazy" src="/icons/washicon.svg" className={className} />;
};
export const ICON_PROGRAM_MYIRON = ({ className }) => {
  return <img loading="lazy" src="/icons/ironicon.svg" className={className} />;
};
export const ICON_PROGRAM_MYDRY = ({ className }) => {
  return <img loading="lazy" src="/icons/dryicon.svg" className={className} />;
};
export const ICON_PROGRAM_MYSHOES = ({ className }) => {
  return (
    <img loading="lazy" src="/icons/shoesicon.svg" className={className} />
  );
};
export const ICON_PROGRAM_MYWASH_COLOR = ({ className }) => {
  return <img loading="lazy" src="/icons/wash.png" className={className} />;
};
export const ICON_PROGRAM_MYDRY_COLOR = ({ className }) => {
  return <img loading="lazy" src="/icons/dryclean.png" className={className} />;
};
export const ICON_PROGRAM_MYIRON_COLOR = ({ className }) => {
  return <img loading="lazy" src="/icons/iron.png" className={className} />;
};
export const ICON_PROGRAM_MYSHOE_COLOR = ({ className }) => {
  return <img loading="lazy" src="/icons/shoe.png" className={className} />;
};

export const ICON_PROGRAM_GET_BY_TYPE = ({ type }) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return (
      <div
        className={` bg-laundry-mywash shadow-laundry-shadowblue mr-4  ${STYLE_COMMON_ICON_PROGRAM}`}
      >
        <ICON_PROGRAM_MYWASH />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return (
      <div
        className={`bg-laundry-mydryclean shadow-laundry-shadowyellow mr-4 ${STYLE_COMMON_ICON_PROGRAM}`}
      >
        <ICON_PROGRAM_MYDRY />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return (
      <div
        className={`bg-laundry-myiron shadow-laundry-shadowgreen mr-4 ${STYLE_COMMON_ICON_PROGRAM}`}
      >
        <ICON_PROGRAM_MYIRON />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return (
      <div
        className={`bg-laundry-myshoes shadow-laundry-shadowpink mr-4 ${STYLE_COMMON_ICON_PROGRAM}`}
      >
        <ICON_PROGRAM_MYSHOES />
      </div>
    );
  } else {
    return "Error";
  }
};

export const ICON_PROGRAM_GET_BY_TYPE_FLEX = ({ type }) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return (
      <div
        className={` bg-laundry-mywash shadow-laundry-shadowblue   p-2 rounded-lg shadow-lg  w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20 `}
      >
        <img
          loading="lazy"
          src="/icons/washicon.svg"
          // className=" w-14 h-14  md:w-[56px] md:h-[56px]"
        />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY) {
    return (
      <div
        className={`bg-laundry-mydryclean shadow-laundry-shadowyellow  p-2 rounded-lg shadow-lg  w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20  `}
      >
        <img
          loading="lazy"
          src="/icons/dryicon.svg"
          // className=" w-14 h-14  md:w-[56px] md:h-[56px]"
        />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return (
      <div
        className={`bg-laundry-myiron shadow-laundry-shadowgreen  p-2 rounded-lg shadow-lg  w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20  `}
      >
        <img
          loading="lazy"
          src="/icons/ironicon.svg"
          // className=" w-14 h-14  md:w-[56px] md:h-[56px]"
        />
      </div>
    );
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return (
      <div
        className={`bg-laundry-myshoes shadow-laundry-shadowpink  p-2 rounded-lg shadow-lg  w-14 h-14  xl:w-border_blue xl:h-border_blue 2xl:w-16 2xl:h-16  3xl:w-20 3xl:h-20  `}
      >
        <img
          loading="lazy"
          src="/icons/shoesicon.svg"
          // className=" w-14 h-14  md:w-[56px] md:h-[56px]"
        />
      </div>
    );
  } else {
    return "Error";
  }
};

//HOME
export const ICON_INFO = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 36 36"
    >
      <circle
        cx="17.97"
        cy="10.45"
        r="1.4"
        fill="currentColor"
        class="clr-i-outline clr-i-outline-path-1"
      />
      <path
        fill="currentColor"
        d="M21 25h-2V14.1h-3a1 1 0 0 0 0 2h1V25h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z"
        class="clr-i-outline clr-i-outline-path-2"
      />
      <path
        fill="currentColor"
        d="M18 34a16 16 0 1 1 16-16a16 16 0 0 1-16 16Zm0-30a14 14 0 1 0 14 14A14 14 0 0 0 18 4Z"
        class="clr-i-outline clr-i-outline-path-3"
      />
      <path fill="none" d="M0 0h36v36H0z" />
    </svg>
  );
};
export const ICON_TRASH = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  );
};

//FAQ
export const ICON_DOWN = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
};
export const ICON_UP = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
    </svg>
  );
};

//BUTTON
export const ICON_CHEVRON_LEFT = ({ className, onClick = () => {} }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  );
};

//CONTACT
export const ICON_WHATSAPP = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="white"
        fill-rule="evenodd"
        d="M17.415 14.382c-.298-.149-1.759-.867-2.031-.967c-.272-.099-.47-.148-.669.15c-.198.296-.767.966-.94 1.164c-.174.199-.347.223-.644.075c-.297-.15-1.255-.463-2.39-1.475c-.883-.788-1.48-1.761-1.653-2.059c-.173-.297-.019-.458.13-.606c.134-.133.297-.347.446-.52c.149-.174.198-.298.297-.497c.1-.198.05-.371-.025-.52c-.074-.149-.668-1.612-.916-2.207c-.241-.579-.486-.5-.668-.51c-.174-.008-.372-.01-.57-.01c-.198 0-.52.074-.792.372c-.273.297-1.04 1.016-1.04 2.479c0 1.462 1.064 2.875 1.213 3.074c.149.198 2.095 3.2 5.076 4.487c.71.306 1.263.489 1.694.625c.712.227 1.36.195 1.872.118c.57-.085 1.758-.719 2.006-1.413c.247-.694.247-1.289.173-1.413c-.074-.124-.272-.198-.57-.347Zm-5.422 7.403h-.004a9.87 9.87 0 0 1-5.032-1.378l-.36-.214l-3.742.982l.999-3.648l-.235-.374a9.861 9.861 0 0 1-1.511-5.26c.002-5.45 4.436-9.884 9.889-9.884c2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.993c-.002 5.45-4.436 9.885-9.884 9.885Zm8.412-18.297A11.815 11.815 0 0 0 11.992 0C5.438 0 .102 5.335.1 11.892a11.864 11.864 0 0 0 1.587 5.945L0 24l6.304-1.654a11.881 11.881 0 0 0 5.684 1.448h.005c6.554 0 11.89-5.335 11.892-11.893a11.821 11.821 0 0 0-3.48-8.413"
        clip-rule="evenodd"
      />
    </svg>
  );
};
export const ICON_WECHAT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M18.574 13.711a.91.91 0 0 0 .898-.898c0-.498-.399-.898-.898-.898s-.898.4-.898.898c0 .5.4.898.898.898zm-4.425 0a.91.91 0 0 0 .898-.898c0-.498-.4-.898-.898-.898-.5 0-.898.4-.898.898 0 .5.399.898.898.898zm6.567 5.04a.347.347 0 0 0-.172.37c0 .048 0 .097.025.147.098.417.294 1.081.294 1.106 0 .073.025.122.025.172a.22.22 0 0 1-.221.22c-.05 0-.074-.024-.123-.048l-1.449-.836a.799.799 0 0 0-.344-.098c-.073 0-.147 0-.196.024-.688.197-1.4.295-2.161.295-3.66 0-6.607-2.457-6.607-5.505 0-3.047 2.947-5.505 6.607-5.505 3.659 0 6.606 2.458 6.606 5.505 0 1.647-.884 3.146-2.284 4.154zM16.673 8.099a9.105 9.105 0 0 0-.28-.005c-4.174 0-7.606 2.86-7.606 6.505 0 .554.08 1.09.228 1.6h-.089a9.963 9.963 0 0 1-2.584-.368c-.074-.025-.148-.025-.222-.025a.832.832 0 0 0-.418.123l-1.748 1.005c-.05.025-.099.05-.148.05a.273.273 0 0 1-.27-.27c0-.074.024-.123.049-.197.024-.024.246-.834.369-1.324 0-.05.024-.123.024-.172a.556.556 0 0 0-.221-.442C2.058 13.376 1 11.586 1 9.598 1 5.945 4.57 3 8.95 3c3.765 0 6.93 2.169 7.723 5.098zm-5.154.418c.573 0 1.026-.477 1.026-1.026 0-.573-.453-1.026-1.026-1.026s-1.026.453-1.026 1.026.453 1.026 1.026 1.026zm-5.26 0c.573 0 1.027-.477 1.027-1.026 0-.573-.454-1.026-1.027-1.026-.572 0-1.026.453-1.026 1.026s.454 1.026 1.026 1.026z"
        fill="rgba(255,255,255,1)"
      />
    </svg>
  );
};
export const ICON_MESSENGER = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 256 256"
    >
      <defs>
        <radialGradient
          id="svgIDa"
          cx="19.247%"
          cy="99.465%"
          r="108.96%"
          fx="19.247%"
          fy="99.465%"
        >
          <stop offset="0%" stop-color="#09F" />
          <stop offset="60.975%" stop-color="#A033FF" />
          <stop offset="93.482%" stop-color="#FF5280" />
          <stop offset="100%" stop-color="#FF7061" />
        </radialGradient>
      </defs>
      <path
        fill="url(#svgIDa)"
        d="M128 0C55.894 0 0 52.818 0 124.16c0 37.317 15.293 69.562 40.2 91.835c2.09 1.871 3.352 4.493 3.438 7.298l.697 22.77c.223 7.262 7.724 11.988 14.37 9.054L84.111 243.9a10.218 10.218 0 0 1 6.837-.501c11.675 3.21 24.1 4.92 37.052 4.92c72.106 0 128-52.818 128-124.16S200.106 0 128 0Z"
      />
      <path
        fill="#FFF"
        d="m51.137 160.47l37.6-59.653c5.98-9.49 18.788-11.853 27.762-5.123l29.905 22.43a7.68 7.68 0 0 0 9.252-.027l40.388-30.652c5.39-4.091 12.428 2.36 8.82 8.085l-37.6 59.654c-5.981 9.489-18.79 11.852-27.763 5.122l-29.906-22.43a7.68 7.68 0 0 0-9.25.027l-40.39 30.652c-5.39 4.09-12.427-2.36-8.818-8.085Z"
      />
    </svg>
  );
};
export const ICON_TELEGRAM = ({ className, onClick }) => {
  return (
    <img
      onClick={onClick}
      loading="lazy"
      src="/icons/telegram.svg"
      className={className}
    />
  );
};
export const ICON_VIBER = ({ className, onClick }) => {
  return <img loading="lazy" src="/icons/viber.svg" className={className} />;
};
export const ICON_SIGNAL_APP = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 16 16"
    >
      <path
        fill="white"
        d="m6.08.234l.179.727a7.264 7.264 0 0 0-2.01.832l-.383-.643A7.9 7.9 0 0 1 6.079.234zm3.84 0L9.742.96a7.265 7.265 0 0 1 2.01.832l.388-.643A7.957 7.957 0 0 0 9.92.234zm-8.77 3.63a7.944 7.944 0 0 0-.916 2.215l.727.18a7.264 7.264 0 0 1 .832-2.01l-.643-.386zM.75 8a7.3 7.3 0 0 1 .081-1.086L.091 6.8a8 8 0 0 0 0 2.398l.74-.112A7.262 7.262 0 0 1 .75 8zm11.384 6.848l-.384-.64a7.23 7.23 0 0 1-2.007.831l.18.728a7.965 7.965 0 0 0 2.211-.919zM15.251 8c0 .364-.028.727-.082 1.086l.74.112a7.966 7.966 0 0 0 0-2.398l-.74.114c.054.36.082.722.082 1.086zm.516 1.918l-.728-.18a7.252 7.252 0 0 1-.832 2.012l.643.387a7.933 7.933 0 0 0 .917-2.219zm-6.68 5.25c-.72.11-1.453.11-2.173 0l-.112.742a7.99 7.99 0 0 0 2.396 0l-.112-.741zm4.75-2.868a7.229 7.229 0 0 1-1.537 1.534l.446.605a8.07 8.07 0 0 0 1.695-1.689l-.604-.45zM12.3 2.163c.587.432 1.105.95 1.537 1.537l.604-.45a8.06 8.06 0 0 0-1.69-1.691l-.45.604zM2.163 3.7A7.242 7.242 0 0 1 3.7 2.163l-.45-.604a8.06 8.06 0 0 0-1.691 1.69l.604.45zm12.688.163l-.644.387c.377.623.658 1.3.832 2.007l.728-.18a7.931 7.931 0 0 0-.916-2.214zM6.913.831a7.254 7.254 0 0 1 2.172 0l.112-.74a7.985 7.985 0 0 0-2.396 0l.112.74zM2.547 14.64L1 15l.36-1.549l-.729-.17l-.361 1.548a.75.75 0 0 0 .9.902l1.548-.357l-.17-.734zM.786 12.612l.732.168l.25-1.073A7.187 7.187 0 0 1 .96 9.74l-.727.18a8 8 0 0 0 .736 1.902l-.184.79zm3.5 1.623l-1.073.25l.17.731l.79-.184c.6.327 1.239.574 1.902.737l.18-.728a7.197 7.197 0 0 1-1.962-.811l-.007.005zM8 1.5a6.502 6.502 0 0 0-6.498 6.502a6.516 6.516 0 0 0 .998 3.455l-.625 2.668L4.54 13.5a6.502 6.502 0 0 0 6.93-11A6.516 6.516 0 0 0 8 1.5"
      />
    </svg>
  );
};
export const ICON_KAKAO = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M12 3c5.799 0 10.5 3.664 10.5 8.185 0 4.52-4.701 8.184-10.5 8.184a13.5 13.5 0 0 1-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866C1.5 6.665 6.201 3 12 3zm5.907 8.06l1.47-1.424a.472.472 0 0 0-.656-.678l-1.928 1.866V9.282a.472.472 0 0 0-.944 0v2.557a.471.471 0 0 0 0 .222V13.5a.472.472 0 0 0 .944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 1 0 .773-.543l-1.514-2.155zm-2.958 1.924h-1.46V9.297a.472.472 0 0 0-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 1 0 0-.944zm-5.857-1.092l.696-1.707.638 1.707H9.092zm2.523.488l.002-.016a.469.469 0 0 0-.127-.32l-1.046-2.8a.69.69 0 0 0-.627-.474.696.696 0 0 0-.653.447l-1.661 4.075a.472.472 0 0 0 .874.357l.33-.813h2.07l.299.8a.472.472 0 1 0 .884-.33l-.345-.926zM8.293 9.302a.472.472 0 0 0-.471-.472H4.577a.472.472 0 1 0 0 .944h1.16v3.736a.472.472 0 0 0 .944 0V9.774h1.14c.261 0 .472-.212.472-.472z"
        fill="currentColor"
      />
    </svg>
  );
};

//MORE
export const ICON_HOME_BLUE = ({ className }) => {
  return <img loading="lazy" src="/icons/home.svg" className={className} />;
};
export const ICON_TERM_BLUE = ({ className }) => {
  return <img loading="lazy" src="/icons/term.svg" className={className} />;
};
export const ICON_PRIVACY_BLUE = ({ className }) => {
  return <img loading="lazy" src="/icons/privacy.svg" className={className} />;
};

//FLAG
export const ICON_ENGLISH = ({ className }) => {
  return <img loading="lazy" src="/icons/flag_eng.svg" className={className} />;
};
export const ICON_ENGLISH_40_30 = ({ className }) => {
  return <img loading="lazy" src="/icons/english.svg" className={className} />;
};
export const ICON_THAI = ({ className }) => {
  return (
    <img loading="lazy" src="/icons/flag_thai.svg" className={className} />
  );
};
export const ICON_THAI_40_30 = ({ className }) => {
  return <img loading="lazy" src="/icons/thai.svg" className={className} />;
};
export const ICON_JAPAN = ({ className }) => {
  return <img loading="lazy" src="/icons/japan.svg" className={className} />;
};
export const ICON_CHECK = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ariaHidden="true"
      role="img"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.392 1.392 0 0 1 .27-1.951a1.392 1.392 0 0 1 1.953.27l2.351 3.104l5.911-9.492a1.396 1.396 0 0 1 1.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 0 1-1.12.656c-.022.002-.042.002-.064.002z"
      />
    </svg>
  );
};

//LOGIN
export const ICON_FULLNAME = ({ className }) => {
  return <img loading="lazy" src="/icons/name.svg" className={className} />;
};
export const ICON_EMAIL = ({ className }) => {
  return <img loading="lazy" src="/icons/email.svg" className={className} />;
};
export const ICON_VERIFY = ({ className }) => {
  return <img loading="lazy" src="/icons/verify.svg" className={className} />;
};
export const ICON_X_INPUT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4668 16.9336C13.0903 16.9336 16.9336 13.0986 16.9336 8.4668C16.9336 3.84326 13.082 0 8.4585 0C3.82666 0 0 3.84326 0 8.4668C0 13.0986 3.83496 16.9336 8.4668 16.9336ZM5.48682 12.1523C5.09668 12.1523 4.78125 11.8369 4.78125 11.4468C4.78125 11.2559 4.86426 11.0898 4.99707 10.9653L7.4707 8.4751L4.99707 5.98486C4.86426 5.86865 4.78125 5.69434 4.78125 5.50342C4.78125 5.12158 5.09668 4.81445 5.48682 4.81445C5.67773 4.81445 5.84375 4.88916 5.96826 5.02197L8.4585 7.50391L10.9653 5.01367C11.1064 4.86426 11.2559 4.79785 11.4385 4.79785C11.8286 4.79785 12.144 5.11328 12.144 5.49512C12.144 5.68604 12.0776 5.84375 11.9365 5.97656L9.44629 8.4751L11.9282 10.9487C12.0527 11.0815 12.1357 11.2476 12.1357 11.4468C12.1357 11.8369 11.8203 12.1523 11.4302 12.1523C11.231 12.1523 11.0649 12.0693 10.9404 11.9448L8.4585 9.45459L5.98486 11.9448C5.86035 12.0776 5.67773 12.1523 5.48682 12.1523Z"
        fill="currentColor"
      />
    </svg>
  );
};

//ADDRESS
export const ICON_EMPTY_ADDRESS = ({ className }) => {
  return (
    <img loading="lazy" src="/images/empty_address.png" className={className} />
  );
};
export const ICON_MAP = ({ className }) => {
  return <img loading="lazy" src="/icons/map.svg" className={className} />;
};
export const ICON_ADDRESS_LOCATION = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z"
        stroke="#ffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z"
        stroke="#ffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_PLUS_ADDRESS = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8809 7.479H6.9819V12.447H5.0269V7.479H0.150902V5.708H5.0269V0.716999H6.9819V5.708H11.8809V7.479Z"
        fill="#FCFCFC"
      />
    </svg>
  );
};
export const ICON_WORK_ADDRESS = ({ className }) => {
  return <img loading="lazy" src="/icons/work.svg" className={className} />;
};
export const ICON_HOME_ADDRESS = ({ className }) => {
  return (
    <img loading="lazy" src="/icons/home_address.svg" className={className} />
  );
};
export const ICON_EDIT = ({ className, onClick }) => {
  return (
    <img
      loading="lazy"
      onClick={onClick}
      src="/icons/edit.svg"
      className={className}
    />
  );
};
export const ICON_STAR = ({ className, onClick, fill, stroke }) => {
  return (
    // <svg
    //   onClick={onClick}
    //   xmlns="http://www.w3.org/2000/svg"
    //   className={className}
    //   preserveAspectRatio="xMidYMid meet"
    //   viewBox="0 0 16 16"
    // >
    //   <path
    //     fill={fill}
    //     stroke={stroke}
    //     d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327l4.898.696c.441.062.612.636.282.95l-3.522 3.356l.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
    //   />
    // </svg>
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0325242 7.21161C-0.0456028 7.4525 0.0195041 7.71747 0.201145 7.89455L4.61717 12.1993L3.57485 18.2768C3.53188 18.5268 3.63474 18.7794 3.83982 18.9284C4.0462 19.0788 4.31769 19.0977 4.5423 18.9792L10 16.1101L15.4577 18.9792C15.5554 19.0307 15.6621 19.056 15.7682 19.056C15.9063 19.056 16.0443 19.0131 16.1602 18.9284C16.3653 18.7794 16.4681 18.5267 16.4251 18.2767L15.3828 12.1993L19.7989 7.89455C19.9805 7.71747 20.0456 7.45249 19.9675 7.21161C19.8887 6.97008 19.6804 6.79429 19.4291 6.75784L13.3268 5.87111L10.5977 0.341796C10.3737 -0.113932 9.6263 -0.113932 9.40234 0.341796L6.67316 5.87111L0.570926 6.75784C0.319632 6.7943 0.111298 6.97008 0.0325242 7.21161Z"
        fill="#3AB4ED"
      />
    </svg>
  );
};

export const ICON_STAR_OUTLINE = ({ className, onClick, fill, stroke }) => {
  const [hover, setHover] = React.useState(false);

  if (hover) {
    return (
      <svg
        className={className}
        onClick={onClick}
        viewBox="0 0 20 20"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0325242 7.21161C-0.0456028 7.4525 0.0195041 7.71747 0.201145 7.89455L4.61717 12.1993L3.57485 18.2768C3.53188 18.5268 3.63474 18.7794 3.83982 18.9284C4.0462 19.0788 4.31769 19.0977 4.5423 18.9792L10 16.1101L15.4577 18.9792C15.5554 19.0307 15.6621 19.056 15.7682 19.056C15.9063 19.056 16.0443 19.0131 16.1602 18.9284C16.3653 18.7794 16.4681 18.5267 16.4251 18.2767L15.3828 12.1993L19.7989 7.89455C19.9805 7.71747 20.0456 7.45249 19.9675 7.21161C19.8887 6.97008 19.6804 6.79429 19.4291 6.75784L13.3268 5.87111L10.5977 0.341796C10.3737 -0.113932 9.6263 -0.113932 9.40234 0.341796L6.67316 5.87111L0.570926 6.75784C0.319632 6.7943 0.111298 6.97008 0.0325242 7.21161Z"
          fill="#3AB4ED"
        />
      </svg>
    );
  } else {
    return (
      <svg
        className={`${className} ${hover ? " text-laundry-primary-blue " : ""}`}
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0325242 7.21161C-0.0456028 7.4525 0.0195041 7.71747 0.201145 7.89455L4.61717 12.1993L3.57485 18.2768C3.53188 18.5268 3.63474 18.7794 3.83982 18.9284C4.0462 19.0788 4.31769 19.0977 4.5423 18.9792L10 16.1101L15.4577 18.9792C15.5554 19.0307 15.6621 19.056 15.7682 19.056C15.9063 19.056 16.0443 19.0131 16.1602 18.9284C16.3653 18.7794 16.4681 18.5267 16.4251 18.2767L15.3828 12.1993L19.7989 7.89455C19.9805 7.71747 20.0456 7.45249 19.9675 7.21161C19.8887 6.97008 19.6804 6.79429 19.4291 6.75784L13.3268 5.87111L10.5977 0.341796C10.3737 -0.113932 9.6263 -0.113932 9.40234 0.341796L6.67316 5.87111L0.570926 6.75784C0.319632 6.7943 0.111298 6.97008 0.0325242 7.21161ZM7.21158 7.14C7.42903 7.10874 7.61653 6.97203 7.71354 6.77541L10 2.14324L12.2865 6.77541C12.3835 6.97202 12.571 7.10874 12.7884 7.14L17.9004 7.88284L14.2012 11.489C14.0443 11.642 13.9727 11.8627 14.0098 12.0788L14.8828 17.1706L10.3106 14.767C10.2129 14.7155 10.1068 14.6902 10 14.6902C9.89323 14.6902 9.78711 14.7155 9.68946 14.767L5.11717 17.1706L5.99022 12.0788C6.02733 11.8627 5.95572 11.642 5.79882 11.489L2.09958 7.88283L7.21158 7.14Z"
          fill="#4E4B66"
        />
      </svg>
    );
  }
};
//PRICING
export const ICON_DOWN_PRICING = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.22 8.47a.75.75 0 0 1 1.06 0L12 15.19l6.72-6.72a.75.75 0 1 1 1.06 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L4.22 9.53a.75.75 0 0 1 0-1.06Z"
      />
    </svg>
  );
};

export const ICON_UP_PRICING = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4.22 15.53a.75.75 0 0 0 1.06 0L12 8.81l6.72 6.72a.75.75 0 1 0 1.06-1.06l-7.25-7.25a.75.75 0 0 0-1.06 0l-7.25 7.25a.75.75 0 0 0 0 1.06Z"
      />
    </svg>
  );
};

export const ICON_PAYPAL = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="2119"
      className={className}
      style={{
        marginTop: "-4px",
      }}
      height="17"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 302"
    >
      <path
        fill="#27346A"
        d="M217.168 23.507C203.234 7.625 178.046.816 145.823.816h-93.52A13.393 13.393 0 0 0 39.076 12.11L.136 259.077c-.774 4.87 2.997 9.28 7.933 9.28h57.736l14.5-91.971-.45 2.88c1.033-6.501 6.593-11.296 13.177-11.296h27.436c53.898 0 96.101-21.892 108.429-85.221.366-1.873.683-3.696.957-5.477-1.556-.824-1.556-.824 0 0 3.671-23.407-.025-39.34-12.686-53.765"
      />
      <path
        fill="#27346A"
        d="M102.397 68.84a11.737 11.737 0 0 1 5.053-1.14h73.318c8.682 0 16.78.565 24.18 1.756a101.6 101.6 0 0 1 6.177 1.182 89.928 89.928 0 0 1 8.59 2.347c3.638 1.215 7.026 2.63 10.14 4.287 3.67-23.416-.026-39.34-12.687-53.765C203.226 7.625 178.046.816 145.823.816H52.295C45.71.816 40.108 5.61 39.076 12.11L.136 259.068c-.774 4.878 2.997 9.282 7.925 9.282h57.744L95.888 77.58a11.717 11.717 0 0 1 6.509-8.74z"
      />
      <path
        fill="#2790C3"
        d="M228.897 82.749c-12.328 63.32-54.53 85.221-108.429 85.221H93.024c-6.584 0-12.145 4.795-13.168 11.296L61.817 293.621c-.674 4.262 2.622 8.124 6.934 8.124h48.67a11.71 11.71 0 0 0 11.563-9.88l.474-2.48 9.173-58.136.591-3.213a11.71 11.71 0 0 1 11.562-9.88h7.284c47.147 0 84.064-19.154 94.852-74.55 4.503-23.15 2.173-42.478-9.739-56.054-3.613-4.112-8.1-7.508-13.327-10.28-.283 1.79-.59 3.604-.957 5.477z"
      />
      <path
        fill="#1F264F"
        d="M216.952 72.128a89.928 89.928 0 0 0-5.818-1.49 109.904 109.904 0 0 0-6.177-1.174c-7.408-1.199-15.5-1.765-24.19-1.765h-73.309a11.57 11.57 0 0 0-5.053 1.149 11.683 11.683 0 0 0-6.51 8.74l-15.582 98.798-.45 2.88c1.025-6.501 6.585-11.296 13.17-11.296h27.444c53.898 0 96.1-21.892 108.428-85.221.367-1.873.675-3.688.958-5.477-3.122-1.648-6.501-3.072-10.14-4.279a83.26 83.26 0 0 0-2.77-.865"
      />
    </svg>
  );
};

export const ICON_ALIPAY = ({ className, onClick }) => {
  return (
    <svg
      viewBox="0 0 854.9970000000001 299.99699999999996"
      xmlns="http://www.w3.org/2000/svg"
      // width="2500"
      className={className}
      height="18"
    >
      <path
        d="M48.508 0C21.694 0 0 21.511 0 48.068v203.87c0 26.536 21.694 48.059 48.508 48.059h205.81c26.793 0 48.496-21.522 48.496-48.059v-2.086c-.902-.372-78.698-32.52-118.24-51.357-26.677 32.524-61.086 52.256-96.812 52.256-60.412 0-80.927-52.38-52.322-86.86 6.237-7.517 16.847-14.698 33.314-18.718 25.76-6.27 66.756 3.915 105.18 16.477 6.912-12.614 12.726-26.506 17.057-41.297H72.581v-11.88h61.057V87.168H59.687V75.28h73.951v-30.39s0-5.119 5.236-5.119h29.848v35.508h73.107v11.891h-73.107v21.303h59.674c-5.71 23.176-14.38 44.509-25.264 63.236 18.111 6.49 34.368 12.646 46.484 16.666 40.413 13.397 51.74 15.034 53.201 15.205V48.069c0-26.557-21.704-48.068-48.496-48.068H48.511zm33.207 162.54c-2.593.03-5.198.17-7.822.426-7.565.753-21.768 4.06-29.533 10.865-23.274 20.109-9.344 56.87 37.762 56.87 27.383 0 54.743-17.343 76.236-45.114-27.71-13.395-51.576-23.335-76.643-23.047z"
        fill="#00a1e9"
      />
      <path
        d="M829.48 208.55l-13.517 29.164-13.718-29.164h-13.402l20.871 40.322v28.127h12.295v-28.127l.074-.157 20.787-40.165zm-98.969 17.644l9.535 28.389h-19.407zm12.464 37.015l4.594 13.786h12.885l-25.37-68.45h-9.851l-25.286 68.45h12.896l4.793-13.786zm-96.164-21.937h-13.686v-23.417h13.686c6.88 0 10.989 5.977 10.989 11.755 0 5.653-3.846 11.661-10.989 11.661m.695-32.723h-26.772v68.45h12.39v-26.316h14.381c13.36 0 22.694-8.667 22.694-21.072s-9.334-21.061-22.694-21.061m-89.406 68.45H570.5v-68.45h-12.4zm-87.163-68.449V277h41.711v-9.327h-29.32V208.55zm-70.587 17.644l9.525 28.389h-19.396zm12.464 37.015l4.594 13.786h12.875l-25.37-68.45h-9.84l-25.287 68.45h12.885l4.794-13.786zm87.23-188.47H446.89V55.813h61.635V44.026H446.89V20.044h-27.477c-3.013 0-5.447 2.512-5.447 5.6v18.382h-61.203v11.787h61.203V74.74H362.31v11.776H465.2s-5.7 22.12-33.925 45.891c-25.286-19.02-33.736-34.167-33.736-34.167h-27.604c11.168 19.23 27.035 34.628 44.124 46.844-15.698 10.133-36.054 19.9-62.372 27.72v14.11s40.605-7.61 79.851-30.587c39.31 22.8 78.787 30.587 78.787 30.587v-13.357c-25.265-9.138-45.283-19.188-61.002-28.88 22.768-16.76 42.723-39.507 50.72-69.937m172.66-52.334h-27.668V51.13h-68.198v11.567h68.198v103.27c-.242 2.366-2.117 4.208-4.467 4.334h-14.065v11.965h35.864c5.679-.23 10.21-4.91 10.336-10.709V62.696h11.231V51.129h-11.23zm-58.349 59.777c-1.011-2.051-3.076-3.465-5.478-3.486h-23.052l17.964 56.192h27.267zm-68.092-61.137L514.527 95.63h24.348v88.747H565.5V66.656h-9.65l20.05-45.609zm308.73 159.26l-9.724-32.639c-.653-2.083-2.55-3.59-4.805-3.59h-25.78l7.48 25.07H791.85v-48.57h59.517v-11.557H791.85V86.157h59.517V74.6h-148.52v11.557h59.506v22.862h-59.506v11.557h59.506v48.57h-59.506v11.558h152.15l-.127-.398zm-121.2-133.28h86.678v17.052h30.965V43.874c-.01-.042-.01-.063-.01-.115 0-4.543-3.582-8.217-8.018-8.29h-50.108V19.568H760.9v15.9h-58.063v28.61h30.954z"
        fill="#3f3b3a"
      />
    </svg>
  );
};

export const ICON_TRUEMONEY = ({ className, onClick }) => {
  return (
    <img
      style={{
        height: "18px",
      }}
      className={className}
      src="/icons/truemoney.png"
    />
  );
};

export const ICON_WhatApps = () => {
  return (
    <img
      onClick={() => {
        FunctionOpenInNewTab("http://wa.me/66925165458");
      }}
      style={{
        height: "28px",
      }}
      className="my-auto flex-row justify-center cursor-pointer"
      src="/icons/whatapp.png"
    />
    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 175.216 175.552">
    //   <defs>
    //     <linearGradient
    //       id="b"
    //       x1="85.915"
    //       x2="86.535"
    //       y1="32.567"
    //       y2="137.092"
    //       gradientUnits="userSpaceOnUse"
    //     >
    //       <stop offset="0" stop-color="#57d163" />
    //       <stop offset="1" stop-color="#23b33a" />
    //     </linearGradient>
    //     <filter
    //       id="a"
    //       width="1.115"
    //       height="1.114"
    //       x="-.057"
    //       y="-.057"
    //       color-interpolation-filters="sRGB"
    //     >
    //       <feGaussianBlur stdDeviation="3.531" />
    //     </filter>
    //   </defs>
    //   <path
    //     fill="#b3b3b3"
    //     d="m54.532 138.45 2.235 1.324c9.387 5.571 20.15 8.518 31.126 8.523h.023c33.707 0 61.139-27.426 61.153-61.135.006-16.335-6.349-31.696-17.895-43.251A60.75 60.75 0 0 0 87.94 25.983c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.312-6.179 22.558zm-40.811 23.544L24.16 123.88c-6.438-11.154-9.825-23.808-9.821-36.772.017-40.556 33.021-73.55 73.578-73.55 19.681.01 38.154 7.669 52.047 21.572s21.537 32.383 21.53 52.037c-.018 40.553-33.027 73.553-73.578 73.553h-.032c-12.313-.005-24.412-3.094-35.159-8.954zm0 0"
    //     filter="url(#a)"
    //   />
    //   <path
    //     fill="#fff"
    //     d="m12.966 161.238 10.439-38.114a73.42 73.42 0 0 1-9.821-36.772c.017-40.556 33.021-73.55 73.578-73.55 19.681.01 38.154 7.669 52.047 21.572s21.537 32.383 21.53 52.037c-.018 40.553-33.027 73.553-73.578 73.553h-.032c-12.313-.005-24.412-3.094-35.159-8.954z"
    //   />
    //   <path
    //     fill="url(#linearGradient1780)"
    //     d="M87.184 25.227c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.312-6.179 22.559 23.146-6.069 2.235 1.324c9.387 5.571 20.15 8.518 31.126 8.524h.023c33.707 0 61.14-27.426 61.153-61.135a60.75 60.75 0 0 0-17.895-43.251 60.75 60.75 0 0 0-43.235-17.929z"
    //   />
    //   <path
    //     fill="url(#b)"
    //     d="M87.184 25.227c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.313-6.179 22.558 23.146-6.069 2.235 1.324c9.387 5.571 20.15 8.517 31.126 8.523h.023c33.707 0 61.14-27.426 61.153-61.135a60.75 60.75 0 0 0-17.895-43.251 60.75 60.75 0 0 0-43.235-17.928z"
    //   />
    //   <path
    //     fill="#fff"
    //     fill-rule="evenodd"
    //     d="M68.772 55.603c-1.378-3.061-2.828-3.123-4.137-3.176l-3.524-.043c-1.226 0-3.218.46-4.902 2.3s-6.435 6.287-6.435 15.332 6.588 17.785 7.506 19.013 12.718 20.381 31.405 27.75c15.529 6.124 18.689 4.906 22.061 4.6s10.877-4.447 12.408-8.74 1.532-7.971 1.073-8.74-1.685-1.226-3.525-2.146-10.877-5.367-12.562-5.981-2.91-.919-4.137.921-4.746 5.979-5.819 7.206-2.144 1.381-3.984.462-7.76-2.861-14.784-9.124c-5.465-4.873-9.154-10.891-10.228-12.73s-.114-2.835.808-3.751c.825-.824 1.838-2.147 2.759-3.22s1.224-1.84 1.836-3.065.307-2.301-.153-3.22-4.032-10.011-5.666-13.647"
    //   />
    // </svg>
  );
};
